import React from "react";
import { initI18nFromSSR } from "./i18n/initFromSSR";
import CartIndex from "./features/cart/CartIndex";
import { getJsonAttribute } from "../frontend/bootstrap/runtime";
import {
  PageAppRegistry,
  mountPageApp,
} from "../frontend/bootstrap/pageAppRegistry";

//init dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validateCartSettings } from "./types/CartSettings";

dayjs.extend(utc);
dayjs.extend(timezone);

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const registry = new PageAppRegistry();

  registry.register("cart", () => {
    mountPageApp("cart-app", (root) => {
      const rawSettings = getJsonAttribute<unknown>(
        root,
        "data-cart-settings",
        null
      );
      const cartSettings = rawSettings
        ? validateCartSettings(rawSettings)
        : null;

      return <CartIndex cartSettings={cartSettings} />;
    });
  });

  registry.mount("cart");
});
